<template>
  <div class="container-fluid verify-wrapper">
    <div class="verify-container">
      <div class="auth-header">
        <div class="brand">
          <img src="../assets/images/logo/logo.png" alt="TusCFDI" height="32" />
        </div>
        <div class="auth-link">
          <router-link :to="{ name: 'login' }" class="link">
            Inicio
          </router-link>
        </div>
      </div>

      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-xl-5 col-lg-6 col-md-8 col-12">
          <div v-if="formError" class="alert alert-danger mb-3" role="alert">{{ formError }}</div>
          <RecoverStatusCard
            :email="email"
            :status="status"
            @recover="recoverPassword"
            @resend="resendCode"
            @retry="status = 'pending'"
            @login="() => $router.push({ name: 'login' })"
          />
        </div>
      </div>

      <div class="auth-footer">
        <div class="footer-links">
          <a target="_blank" href="https://tuscfdis.com/terminos">Términos</a>
          <a target="_blank" href="https://tuscfdis.com/politica-privacidad">Privacidad</a>
        </div>
        <small>© 2026 TusCFDIs.</small>
      </div>
    </div>
  </div>
</template>

<script>
import RecoverStatusCard from '@/components/auth/recoverStatusCard.vue';
import ws from '@/services/login';

export default {
  name: 'recover-password',
  components: {
    RecoverStatusCard
  },
  data() {
    return {
      email: this.$route.query.email || '',
      status: 'pending', // pending | success | error
      formError: ''
    };
  },
  methods: {
    async sendRecover(email) {
      this.formError = '';
      this.$loading.show();
      try {
        const res = await ws.recoverPassword({ email });
        if (res.type === 'success') {
          this.email = email;
          this.status = 'success';
          this.$toast.success('Te enviamos las instrucciones a tu correo');
          return true;
        }

        this.status = 'error';
        this.formError = res.message || 'No fue posible enviar el correo';
        return false;
      } catch (e) {
        this.status = 'error';
        this.formError = 'Error al iniciar recuperación de contraseña';
        return false;
      } finally {
        this.$loading.hide();
      }
    },
    async recoverPassword(email) {
      await this.sendRecover(email);
    },
    async resendCode() {
      if (!this.email) {
        this.status = 'pending';
        return;
      }
      await this.sendRecover(this.email);
    }
  }
};
</script>
